import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.WarrantyModal
*
* Encapsulates the functionality of a modal dialog that contains the N.E.W NISC.
**/
HSN.WarrantyModal = (function (_super) {
    __extends(WarrantyModal, _super);

    function WarrantyModal() {
        /**
    * new HSN.WarrantyModal()
    **/
        return WarrantyModal.__super__.constructor.call(this);
    }

    /**
    * HSN.WarrantyModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    WarrantyModal.prototype._show = function (webPId, warrWebPId, prodPrice, sourceId, url) {
            
        $.ajax(url + "/Get?" + new Date().getTime(),
            {
            context: this,
            dataType: 'html',
            data: { 'WebPId': webPId, 'WarrWebPId': warrWebPId, 'ProdPrice': prodPrice, 'SourceLocation': sourceId},
            success: function (data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');
                
                this.Content.showHtml
            (
                data,
                0,
                function () {
                __scope.Center();
                __scope.Content.animate({ opacity: 1 });
                },
                function () {
                    //__scope.Center();
                }
            );
                
            },
            error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        }
    );
    };

    return WarrantyModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/WarrantyModal.js